/**
 * Created by CoolGuy on 2017/6/17.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
import moment from 'moment';
const {
    ajaxCommon,
    ajaxv2, DOMAIN_CURRENT
} = Ajax;
export const TheApi = API('Order');
const ORDER_ADD = "ORDER_ADD";
const ORDER_LIST = "ORDER_LIST";
const ORDER_EDIT = "ORDER_EDIT";
const ORDER_DETAIL = "ORDER_DETAIL";
const ORDER_DELETE = "ORDER_DELETE";
const ORDER_DASH = "ORDER_DASH";
const ORDER_BALANCE = "ORDER_BALANCE";
const ORDER_EXPORT = "ORDER_EXPORT";
const ORDER_EXPORT_MAIL = "ORDER_EXPORT_MAIL";
const ORDER_TAGS = "ORDER_TAGS";
const ORDER_MODIFY_CHECK = "ORDER_MODIFY_CHECK";
const ORDER_TAGS_CATEGORY = "ORDER_TAGS_CATEGORY";
const CURRENT_ORDER_MODIFY = "CURRENT_ORDER_MODIFY";
const ORDER_MERGE_TAGS = "ORDER_MERGE_TAGS";
const ORDER_CLEAR_TAGS = "ORDER_CLEAR_TAGS";
//import {Order as mock} from '../util/TestData';



export default {
    ORDER_BALANCE,
    orderBalanceList:(ids)=>{
        return ajaxCommon({
            api:{
                url:'/api/order/balance_list?ids=' + ids.toString(),
                method:'get'
            },
            success:(data)=>({
                type:ORDER_BALANCE,
                data
            })
        })
    },
    ORDER_EXPORT_MAIL,
    orderExportByMail:(params, email)=>{
      var obj = Object.assign({}, params);
      delete obj.balance_list;
      delete obj.current;
      delete obj.total;
      delete obj.total_balance;
      delete obj.dir;
      delete obj.pageSize;
      delete obj.page;

      obj.email = email;

      return ajaxCommon({
          api:{
              url:'/api/order/exportbymail',
              method:'get'
          },
          data:Object.assign(obj, {
            pageSize:20,
            page:1
          }),
          success:(data)=>({
              type:ORDER_EXPORT_MAIL,
              data
          })
      })
    },
    ORDER_EXPORT,
    orderExport:(params)=>{
        var obj = Object.assign({}, params);
        delete obj.balance_list;
        delete obj.current;
        delete obj.total;
        delete obj.total_balance;
        delete obj.dir;
        delete obj.pageSize;
        delete obj.page;

        return ajaxCommon({
            api:{
                url:'/api/order/export',
                method:'get'
            },
            data:Object.assign(obj, {
              pageSize:100000,
              page:1
            }),
            success:(data)=>({
                type:ORDER_EXPORT,
                data
            })
        })
    },
    ORDER_ADD,
    orderAdd: (one)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:one,
            success: (data)=>({
                type:ORDER_ADD,
                data
            })
        })
    },
    ORDER_LIST,
    orders: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        if(!search.key) {
            delete search.key;
        }
        return ajaxCommon({
            api:TheApi('get')(),
            data:search,
            success: (data)=>({
                type:ORDER_LIST,
                data
            })
        })
    },
    ORDER_DASH,
    orderDash:(lasttime)=>{
        return ajaxCommon({
            api:TheApi('get')(),
            data:{
                key:JSON.stringify({
                    status:['to-confirm', 'confirmed', 'to-scene', 'to-pay', 'payed'],
                    'actionstarttime[<]':lasttime,
                    // 'actionstarttime[>]':moment().subtract(3, 'y').valueOf()
                }),
                page:1,
                pagesize:50,
                sort:'-actionstarttime'
            },
            success:(data)=>({
                type:ORDER_DASH,
                data
            })
        })
    },
    ORDER_EDIT,
    orderEdit: (orderId,info)=>{
        return ajaxCommon({
            api:TheApi("put")(orderId),
            data:info,
            success: (data)=>({
                type:ORDER_EDIT,
                data
            })
        })
    },
    ORDER_TAGS_CATEGORY,
    orderTagCategory:()=>{
      return ajaxCommon({
        api:{
          url:DOMAIN_CURRENT + '/api/v2/tags/category/list',
        },
        success:(res)=>{
          if(res && res.code == 200) {
            let result = {};
            (res.data || []).forEach(it=>{
              result[it.id] = it;
            });

            return {
              type:ORDER_TAGS_CATEGORY,
              data:result
            };
          }
        }
      })
    },
    ORDER_TAGS,
    orderTags:(orderId, defaultHandleError)=>{
      return ajaxCommon({
        api:{
          url:DOMAIN_CURRENT + '/api/v2/order/tags/collection/' + orderId,
        },
        success:(res)=>{
          if(res && res.code == 200) {
            return {
              type:ORDER_TAGS,
              data:res.data
            };
          }
        }
      })
    },
    ORDER_MODIFY_CHECK,
    orderModifyCheck:(orderid)=>{
      return ajaxCommon({
        api:TheApi('get')(`modifycheck?orderid=${orderid}`),
        success:(data)=>({
          type:ORDER_MODIFY_CHECK,
          orderId:orderid,
          data:data.data
        })
      })
    },
    ORDER_DETAIL,
    orderDetail:(orderId,defaultHandleError)=>{
        if(typeof orderId == 'object') {
            return {
                type:ORDER_DETAIL,
                data:orderId
            };
        }else {
            return ajaxCommon({
                defaultHandleError,
                api:TheApi("get")(orderId),
                success:(data)=>({
                    type:ORDER_DETAIL,
                    orderId,
                    data
                })
            })
        }
    },
    ORDER_DELETE,
    orderDelete:(orderId)=>{
        return ajaxCommon({
            api:TheApi("delete")(orderId),
            success:(data)=>({
                type:ORDER_DELETE,
                orderId,
                data
            })
        })
    },
    CURRENT_ORDER_MODIFY,
    currentOrderModify:(key,params)=>{
      return ({
          type:CURRENT_ORDER_MODIFY,
          params,
          key,
      });
    },
    ORDER_MERGE_TAGS,
    mergeOrderTag:(tags, category)=>{
      return {
        type:ORDER_MERGE_TAGS,
        category_id:category.id,
        tags,
      }
    },
    ORDER_CLEAR_TAGS,
    clearOrderTags:()=>{
      return {
        type:ORDER_CLEAR_TAGS,
        tags:{}
      }
    }
}



// WEBPACK FOOTER //
// ./src/actions/OrderAction.js